import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDebounce } from 'use-debounce';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { TextField } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
const qs = require('query-string');

import UserService from "../services/UserService";
import MapCluster from "./MapCluster";
import BrowserListing from "./BrowserListing/BrowserListing";
import EmailOverride from "./EmailOverride";

const sha256 = require('js-sha256');
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function AdminInterface() {
  const classes = useStyles();
  const [browsers, setBrowsers] = useState(null);
  let { location: { search } } = useHistory();
  const [loading, setLoading] = useState(false);
  const [emailRaw, setEmailRaw] = useState(qs.parse(search).email ? qs.parse(search).email.toLowerCase() : null);
  const [email] = useDebounce(emailRaw, 1200);
  const [userIdRaw, setUserIdRaw] = useState(qs.parse(search).user_id);
  const [userId] = useDebounce(userIdRaw, 800);

  let history = useHistory();
  let userService;

  const queryData = () => {
    setLoading(true);
    setBrowsers(null);
    new UserService().getBrowsers(userId)
      .then((data) => {
        setBrowsers(data);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (!email && userId) {
      history.replace({
        search: `?user_id=${userId}`
      });
    }
  }, [email, userId]);

  useEffect(() => {
    if (email) {
      setUserIdRaw(sha256(email));
      history.replace({
        search: `?email=${email}`
      });
    }
  }, [email]);

  useEffect(() => {
    if (userId) {
      queryData();
    }
  }, [userId]);

  console.log(browsers)

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <TextField
            onChange={(e) => {
              setEmailRaw(e.target.value.toLowerCase().replace(/\s/g, ''));
            }}
            label="Email"
            value={emailRaw}
            fullWidth
            autoFocus
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            onChange={(e) => {
              setUserIdRaw(e.target.value);
            }}
            label="User ID"
            value={userIdRaw}
            disabled={email?true:false}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <EmailOverride userId={userId}/>
        </Grid>               
      </Grid>
        {(!loading && browsers && browsers.length>0) && (    
        <React.Fragment>
          <BrowserListing browsers={browsers} reload={queryData}/>
        </React.Fragment>
        )}
        {!loading && browsers && browsers.length===0 && <div style={{padding:"30px"}}>No Results Found for {email}</div>}
        {loading && <CircularProgress color="inherit" />}
    </div>
  );
}
